class Model {

}

export default Model;